/* ---------------------------------------------------------------
   Kōraru PDP — Matteau gallery. Two small jobs.

   1. Sticky info block. If it fits on screen it sticks just under the
      header. If it is taller than the screen, its sticky offset goes
      negative by the difference, so it scrolls with the page until its
      last line is in view and only then sticks. The theme animates
      `top` on this element (transition: top .3s); that is switched off
      here, or every recalculation would glide.

   2. Phones: the stacked gallery becomes a sideways swipe, so a small
      "2 / 5" counter sits on the image. The theme also renders a
      hidden no-script copy of the gallery; that one is skipped.

   Accordions behave exactly as before (pdp-accordions.liquid).
   --------------------------------------------------------------- */
(function () {
	var DESKTOP = window.matchMedia('(min-width: 990px)');

	function setSticky() {
		var cols = document.querySelectorAll('.product__outer--static-column-aside .product__info-main');
		for (var i = 0; i < cols.length; i++) {
			var col = cols[i];
			col.style.setProperty('transition', 'none', 'important');
			if (!DESKTOP.matches) {
				col.style.removeProperty('--pdp-sticky-top');
				continue;
			}
			var header = document.querySelector('.shopify-section-header');
			var headerH = header ? header.getBoundingClientRect().height : 50;
			var under = headerH + 24;
			var spare = window.innerHeight - col.offsetHeight;
			var top = spare >= under ? under : spare;
			col.style.setProperty('--pdp-sticky-top', Math.round(top) + 'px');
		}
	}

	function setCounters() {
		var lists = document.querySelectorAll('.product__outer--static-column-aside .product__media-list');
		for (var i = 0; i < lists.length; i++) {
			(function (list) {
				if (list.closest('.js-hidden, .product__media-grid-noscript')) return;
				if (list.dataset.pdpCount === 'true') return;
				var items = list.querySelectorAll(':scope > .product__media-item');
				if (items.length < 2) return;
				list.dataset.pdpCount = 'true';

				var host = list.closest('.product__media-list-wrapper') || list.parentNode;
				if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
				var badge = document.createElement('span');
				badge.className = 'pdp-gallery-count';
				badge.setAttribute('aria-hidden', 'true');
				host.appendChild(badge);

				function update() {
					var w = list.clientWidth || 1;
					var n = Math.min(items.length, Math.round(list.scrollLeft / w) + 1);
					badge.textContent = n + ' / ' + items.length;
				}
				list.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
				update();
			})(lists[i]);
		}
	}

	function init() {
		setCounters();
		setSticky();
	}

	var t = null;
	window.addEventListener('resize', function () {
		clearTimeout(t);
		t = setTimeout(setSticky, 120);
	});
	window.addEventListener('load', setSticky);
	if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', setSticky);
	if ('ResizeObserver' in window) {
		var ro = new ResizeObserver(function () { setSticky(); });
		document.querySelectorAll('.product__info-main').forEach(function (el) { ro.observe(el); });
	}
	document.addEventListener('shopify:section:load', init);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
